import React from "react"

interface ExcelIconProps {
  style?: React.CSSProperties;
  onClick?: () => void;
  disabled?: boolean;
}

const ExcelIcon: React.FC<ExcelIconProps> = ({ style, onClick, disabled, ...props }) => (
  <svg
    cursor={disabled ? 'not-allowed' : 'pointer'}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56 56"
    width={70}
    height={70}
    style={{
      background: "new 0 0 56 56",
      ...style,
    }}
    onClick={onClick}
    xmlSpace="preserve"
    {...props}
  >
    <path
      d="M30.753 24.163 13.36 21.088v22.721a1.884 1.884 0 0 0 1.158 1.736c.228.094.471.142.717.142h30.014a1.867 1.867 0 0 0 1.734-1.158c.095-.228.143-.473.144-.72v-8.371L30.753 24.163Z"
      fill="#185C37"
    />
    <path
      d="M30.752 4.688H15.233a1.867 1.867 0 0 0-1.731 1.158 1.886 1.886 0 0 0-.144.72v8.371l17.394 10.25 9.21 3.075 7.163-3.075v-10.25L30.752 4.687Z"
      fill="#21A366"
    />
    <path d="M13.36 14.937h17.393v10.25H13.36v-10.25Z" fill="#107C41" />
    <path
      opacity={0.1}
      d="M25.808 12.887H13.359v25.625h12.449a1.883 1.883 0 0 0 1.322-.553c.352-.352.55-.828.554-1.326V14.765a1.896 1.896 0 0 0-.554-1.325 1.883 1.883 0 0 0-1.322-.553Z"
      fill="#000"
    />
    <path
      opacity={0.2}
      d="M24.785 13.911H13.359v25.625h11.426a1.883 1.883 0 0 0 1.322-.553c.352-.352.55-.828.554-1.326V15.79a1.895 1.895 0 0 0-.554-1.325 1.882 1.882 0 0 0-1.322-.553Z"
      fill="#000"
    />
    <path
      opacity={0.2}
      d="M24.785 13.911H13.359v23.575h11.426c.496-.003.971-.201 1.322-.553.352-.352.55-.828.554-1.325V15.789a1.895 1.895 0 0 0-.554-1.325 1.882 1.882 0 0 0-1.322-.553Z"
      fill="#000"
    />
    <path
      opacity={0.2}
      d="M23.762 13.911H13.359v23.575h10.403c.496-.003.971-.201 1.322-.553.352-.352.55-.828.554-1.325V15.789a1.895 1.895 0 0 0-.554-1.325 1.882 1.882 0 0 0-1.322-.553Z"
      fill="#000"
    />
    <path
      d="M5.001 13.911h18.76c.497 0 .973.197 1.325.55.352.352.55.83.55 1.328v18.794c0 .498-.198.976-.55 1.328-.352.352-.828.55-1.325.55H5a1.87 1.87 0 0 1-1.733-1.159 1.886 1.886 0 0 1-.143-.72V15.79a1.885 1.885 0 0 1 1.159-1.736c.227-.094.471-.142.717-.142Z"
      fill="url(#a)"
    />
    <path
      d="m8.94 31.294 3.945-6.125-3.614-6.09h2.902l1.973 3.9c.182.37.314.644.373.826h.027c.13-.296.266-.581.409-.86l2.109-3.86h2.671l-3.707 6.056 3.801 6.158h-2.842l-2.279-4.275a3.718 3.718 0 0 1-.269-.576h-.037c-.067.194-.155.38-.264.554l-2.347 4.292H8.94Z"
      fill="#fff"
    />
    <path
      d="M45.248 4.688H30.752v10.25h16.372V6.565a1.886 1.886 0 0 0-1.159-1.736 1.867 1.867 0 0 0-.717-.143Z"
      fill="#33C481"
    />
    <path d="M30.752 25.187h16.372v10.25H30.752v-10.25Z" fill="#107C41" />
    <defs>
      <linearGradient
        id="a"
        x1={7.044}
        y1={12.435}
        x2={21.795}
        y2={37.892}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset={0.5} stopColor="#117E43" />
        <stop offset={1} stopColor="#0B6631" />
      </linearGradient>
    </defs>
  </svg>
)

export default ExcelIcon
